import { defineMessages } from 'react-intl';

const emails = defineMessages({
    uniqueEmail: {
        id: 'global.email.uniqueEmail',
        defaultMessage:
            'Each driver must have a unique email address. Duplicates are not allowed.',
    },
});

export default emails;
